"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKSPACE_DECISION_LABELS = exports.WORKSPACE_DECISION_KINDS = exports.workspaceLinks = exports.WORKSPACE_QUERY_KEYS = exports.OFFER_PENDING_RESPONSE_STATUSES = exports.WORKSPACE_DIGEST_ROWS = exports.WORKSPACE_SECTION_LIMIT = exports.WORKSPACE_SECTION_UNITS = exports.WORKSPACE_SECTION_LABELS = exports.WORKSPACE_SECTIONS = void 0;
exports.workspaceCounts = workspaceCounts;
exports.workspaceFigure = workspaceFigure;
exports.workspaceNeedsDigest = workspaceNeedsDigest;
exports.compareDecisions = compareDecisions;
/**
 * RPT-02 — the recruiter's daily home (master plan S27, §L27 RPT-02a). Deliberately not
 * analytics: filtered lists of the signed-in person's own records, each row opening the
 * screen where the work is done (#3), never a list of lists.
 */
exports.WORKSPACE_SECTIONS = ['requisitions', 'sorting', 'interviews', 'decisions', 'tasks', 'offers', 'sla'];
exports.WORKSPACE_SECTION_LABELS = {
    requisitions: 'My requisitions',
    sorting: 'CVs waiting to sort',
    interviews: "Today's interviews",
    decisions: 'Decisions awaiting me',
    tasks: 'Overdue tasks',
    offers: 'Offers pending response',
    sla: 'SLA warnings',
};
/** What each section's figure counts, for its label in the strip and the digest. */
exports.WORKSPACE_SECTION_UNITS = {
    requisitions: ['requisition', 'requisitions'],
    sorting: ['CV', 'CVs'],
    interviews: ['interview', 'interviews'],
    decisions: ['decision', 'decisions'],
    tasks: ['task', 'tasks'],
    offers: ['offer', 'offers'],
    sla: ['warning', 'warnings'],
};
/** Rows drawn per section. The figure is always the full count; the rest are a click away. */
exports.WORKSPACE_SECTION_LIMIT = 50;
/** Rows per section in the 8am email (N-72) — enough to act on before opening the app. */
exports.WORKSPACE_DIGEST_ROWS = 5;
/** The offers that wait on the candidate's answer (§L25). */
exports.OFFER_PENDING_RESPONSE_STATUSES = ['sent', 'viewed', 'negotiating'];
exports.WORKSPACE_QUERY_KEYS = [['workspace']];
// --- Where each row goes (#3: the action screen, never a dashboard) ---------------------------
exports.workspaceLinks = {
    requisition: (id) => `/requisitions/${id}`,
    sort: (jobId) => `/jobs/${jobId}/sort`,
    interview: (id) => `/interviews/${id}`,
    /** N-41's own landing: the round's debrief, where the decision is recorded. */
    round: (interviewId) => `/interviews/${interviewId}/debrief`,
    /** N-65's own landing: DEC-02, whose hold list releases or keeps them. */
    hold: (jobId) => `/jobs/${jobId}/compare`,
    marking: (attemptId) => `/assessments/marking/${attemptId}`,
    task: (id) => `/tasks/${id}`,
    offer: (id) => `/offers/${id}`,
    application: (id) => `/applications/${id}`,
};
/** Q14: rounds ready to decide on my jobs, holds ending or ended, tests I mark. */
exports.WORKSPACE_DECISION_KINDS = ['round', 'hold', 'marking'];
exports.WORKSPACE_DECISION_LABELS = {
    round: 'Round to decide',
    hold: 'Hold ending',
    marking: 'Test to mark',
};
/** Each section's figure — the strip, the section headings and the digest read the same numbers. */
function workspaceCounts(workspace) {
    return {
        requisitions: workspace.requisitions.total,
        sorting: workspace.sorting.total,
        interviews: workspace.interviews.total,
        decisions: workspace.decisions.total,
        tasks: workspace.tasks.total,
        offers: workspace.offers.total,
        sla: workspace.sla.total,
    };
}
/** "3 CVs", "1 task". */
function workspaceFigure(section, count) {
    const [one, many] = exports.WORKSPACE_SECTION_UNITS[section];
    return `${count} ${count === 1 ? one : many}`;
}
/**
 * Whether the morning's email has anything to say. A requisition is standing work, not news:
 * N-72 goes when something else waits, so a quiet day sends nothing.
 */
function workspaceNeedsDigest(workspace) {
    const counts = workspaceCounts(workspace);
    return exports.WORKSPACE_SECTIONS.some((section) => section !== 'requisitions' && counts[section] > 0);
}
/** Ordered for the list: overdue first, then the oldest wait (06-qol "overdue first"). */
function compareDecisions(a, b) {
    if (a.isOverdue !== b.isOverdue)
        return a.isOverdue ? -1 : 1;
    return a.since.localeCompare(b.since);
}
//# sourceMappingURL=workspace.js.map